import React from 'react';
import FoundationContact from '../components/FoundationContact';

const Contact = () => <FoundationContact />;

export default Contact;
